import castArray from "lodash/fp/castArray";
import filter from "lodash/fp/filter";
import flow from "lodash/fp/flow";
import head from "lodash/fp/head";

function matchesLocale(locale) {
  return (obj) => {
    if (!obj?.displayIfLocale) return true;

    const { includes, notIncludes } = obj.displayIfLocale;

    if (includes) return includes.includes(locale);
    if (notIncludes) return !notIncludes.includes(locale);

    return true;
  };
}

export default function shouldBeDisplayedForLocale(locale) {
  return (value) => flow(castArray, filter(matchesLocale(locale)), head)(value);
}
